import render from "./src/render"

// get window width before document ready, some plugins can rewrite the window.width value :D
window.flexWidth = window.innerWidth
$(document).ready(() => render())
